import React, { useCallback } from 'react'

import { COLORS, THEME } from '../../styles'

import Styled from './CoversCountSelector.styled'

const CoversCountSelector = ({
  className,
  coversCount,
  disabled,
  isLoading,
  setCoversCount,
  options,
}) => {
  const handleChange = useCallback(
    (event) => {
      if (!disabled) {
        const selected = options.find(
          (o) => o.toString() === event.target.value,
        )
        const newValue = selected ?? event.target.value
        setCoversCount(newValue)
      }
    },
    [setCoversCount, disabled, options],
  )

  return (
    <Styled className={className}>
      <Styled.container>
        <Styled.select
          onChange={handleChange}
          disabled={disabled}
          isLoading={isLoading}
          value={coversCount ? coversCount.toString() : ''}
        >
          {options.map((option) => (
            <option key={option} value={option.toString()}>
              {option}
            </option>
          ))}
        </Styled.select>
        {isLoading && !disabled ? (
          <Styled.selectLoading fill={COLORS.primary} width={16} height={16} />
        ) : null}
        {disabled ? null : (
          <Styled.selectIcon
            width={8}
            height={8}
            name="selector-16"
            fill={disabled ? THEME.COLORS.foreground.secondary : COLORS.primary}
          />
        )}
        <Styled.coversIcon
          width={16}
          height={16}
          name="serving-16"
          fill={disabled ? THEME.COLORS.foreground.secondary : COLORS.primary}
        />
      </Styled.container>
    </Styled>
  )
}

CoversCountSelector.defaultProps = {
  isLoading: false,
  disabled: false,
  options: [],
}

export default CoversCountSelector
